module.exports = __webpack_public_path__ + "img/thumbnail.151832a9.jpg";